import { render, staticRenderFns } from "./DestinationAddress.vue?vue&type=template&id=508029ca"
import script from "./DestinationAddress.vue?vue&type=script&lang=js"
export * from "./DestinationAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports